<template>
	<div class="myQA ">
		<div class="flex items-center justify-between mb-[20px] pb-[6px] bB-03">
			<div class="flex items-center">
				<div v-for="(item,index) in navList" :key="index"
					:class="type==index?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
					class="navTitle cursor-pointer  relative text-[16px] mr-[34px]">
					{{item.title}}
				</div>
			</div>
			<div @click="create_question_btn()"
				class="min-w-[90px] h-[34px] px-[10px] box-border cursor-pointer leading-[34px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo['Initiate_session']}}
			</div>
		</div>

		<div class="" v-if="isFinish&&dataList.length>0">

			<div class="min-h-[500px]">
				<div v-for="(item,index) in dataList" :key="index"
					class="bg-[#F7F9FC] mb-[10px] flex flex-col justify-between h-[225px] rounded-[5px] pt-[18px]  pb-[16px] pl-[10px] pr-[20px] box-border">
					<div class="">
						<div class="flex justify-between items-center mb-7 ">
							<div class="flex flex-1 mr-[34px]">
								<img class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon07.png" alt=""
									srcset="" />
								<div class="text-[16px] text-[#000000] flex-1">
									{{item.content}}
								</div>
							</div>
							<div class="text-[#9199A1]  text-right">{{item.create_time}}</div>
						</div>
						<div class="flex justify-between  " v-for="(ite,ind) in item.replies" :key="ind">
							<img v-if="ite.user_id>0" class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon07.png"
								alt="" srcset="" />
							<img v-else class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon08.png" alt=""
								srcset="" />
							<div v-if="ite.user_id>0"
								class="leading-[20px] px-[6px] box-border  text-[12px] mr-[9px] text-center text-[#ffffff]  bg-[#FF0000]">
								{{langInfo.phone_follow_up}}
							</div>
							<div class="text-[16px] text-[#000000] flex-1">
								{{ite.content ||langInfo.no_reply_yet}}
							</div>
						</div>
					</div>
					<div class="flex">
						<div @click="followUpBtn(item,index)"
							class="min-w-[90px] h-[34px] cursor-pointer px-[10px] box-border leading-[34px] border border-solid border-[#E8E8E8] rounded-[4px] text-center text-[14px] text-[#696C74]">
							{{langInfo.phone_follow_up}}
						</div>
					</div>

				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<emptyPage v-else-if="isFinish&&dataList.length==0" :title="langInfo.no_data_available">
		</emptyPage>



		<el-dialog :title="community_usercommunity_id?langInfo.phone_follow_up:langInfo.initiate_question"
			@close="close" :visible.sync="visible" :close-on-click-modal="false" width="40%" center>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
				<el-form-item prop="desc">
					<el-input type="textarea" v-model="ruleForm.desc"
						:placeholder="langInfo.phone_content_tip"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="close()">{{langInfo.cancel}}</el-button>
					<el-button type="primary" @click="submitForm('ruleForm')">{{langInfo.submit}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			emptyPage
		},
		name: "myQA",
		data() {
			return {
				type: 0,
				navList: [{
					title: '', //我的问答
				}],

				total: 0,
				page: 1,
				limit: 3,
				isFinish: false,
				dataList: [],
				langInfo: {},

				visible: false,
				ruleForm: {
					desc: ''
				},
				rules: {
					desc: [
						{ required: true, message: '', trigger: 'blur' } //请填写内容
					]
				},

				community_usercommunity_id: '', //传问题的id 是追加提问
				langInfo: {}

			}
		},

		mounted() {
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.rules.desc[0].message = this.langInfo.phone_content_tip
				this.navList[0].title = this.langInfo.study_my_answer
				
				document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_answer
				
			}
			this.get_my_questions()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.rules.desc[0].message = this.langInfo.phone_content_tip
					this.navList[0].title = this.langInfo.study_my_answer
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_answer
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			currentChange(e) {
				console.log(e);
				this.page = e
				this.get_my_questions()
			},
			get_my_questions() {
				this.$api.my_questions({
					page: this.page,
					limit: this.limit
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.dataList = res.data.list
					this.total = res.data.total
				}).catch((error) => {
					this.isFinish = true
				})
			},
			create_question_btn() {
				this.visible = true
				this.ruleForm.desc = ""
				this.community_usercommunity_id = ""


			},
			// 追问
			followUpBtn(item, index) {
				this.community_usercommunity_id = item.id
				this.visible = true
				this.ruleForm.desc = ""
			},
			submitForm(formName) {
				var that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(valid);
						if (valid) {
							let param = {
								content: this.ruleForm.desc,
							}

							if (this.community_usercommunity_id) {
								param.community_usercommunity_id = this.community_usercommunity_id
							}

							that.$api.create_question(param).then((res) => {
								console.log(res);
								// status=0 0是取消1是收藏成功
								this.$message({
									message: res.msg,
									type: 'success'
								})
							}).catch((error) => {
								this.$message({
									message: error.msg,
									type: 'warning'
								})
							})
							setTimeout(() => {
								this.get_my_questions()
								this.visible = false
								this.ruleForm.desc = ""
								this.community_usercommunity_id = ""
							}, 800)
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			close() {
				this.visible = false
				this.ruleForm.desc = ""

			},

		}
	};
</script>

<style scoped>
	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}
</style>